import { Module } from 'vuex';
import {
    TICKETS_DASHBOARD_SET_PAGINATED_TICKETS,
    TICKETS_DASHBOARD_SET_TICKETS,
} from '@/modules/tickets/dashboard/store/tickets-dashboard.mutations';
import {
    TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS,
    TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER,
    TICKETS_DASHBOARD_GET_TICKETS,
} from '@/modules/tickets/dashboard/store/tickets-dashboard.actions';
import APIService from '@/modules/shared/shared/domain/api';
import {
    TICKET_DASHBOARD_GET_TABULATED_TICKETS,
    TICKET_DASHBOARD_GET_PAGES,
} from '@/modules/tickets/dashboard/store/tickets-dashboard.getters';
import { Tickets } from '@/modules/shared/shared/domain/constants/constants';
import { setFormatDate } from '@/modules/shared/shared/domain/functions/date-functions';
import { getStateOfTicket } from '@/modules/tickets/dashboard/store/tickets-dashboard.functions';
import { UserGetters } from '@/modules/users/store/user.getters';
import { User } from '@/modules/users/domain/user';

interface TicketsDashboardInterface {
    serial: number;
    type: string;
    date: string;
    state: { name: string; color: string };
    name?: string;
    creationDate?: string;
}

const apiService = new APIService();
const ticketsDashboard: Module<any, any> = {
    namespaced: true,
    state: {
        tickets: undefined,
        paginatedTickets: undefined,
    },
    getters: {
        [TICKET_DASHBOARD_GET_PAGES](state) {
            return state && state.paginatedTickets ? state.paginatedTickets.pages : 1;
        },
        [TICKET_DASHBOARD_GET_TABULATED_TICKETS](state) {
            const tickets: TicketsDashboardInterface[] = [];

            if (state.paginatedTickets) {
                state.paginatedTickets.results.forEach(i => {
                    let type: string;

                    if (
                        i.typing.id == Tickets.ACCESS.typings.first_access_typing ||
                        i.typing.id == Tickets.ACCESS.typings.second_access_typing
                    ) {
                        if (i.accessPermission && i.accessPermission.accessPermissionMotives[0]) {
                            type =
                                i.accessPermission.accessPermissionMotives[0]
                                    .accessPermissionTypeMotive.accessType.name;
                        } else {
                            type = 'Ticket de Acceso';
                        }
                    } else if (
                        [
                            2148,
                            2149,
                            2150,
                            20028,
                            2152,
                            2153,
                            2154,
                            20027,
                            2156,
                            2157,
                            2159,
                            2158,
                            2161,
                            2162,
                            2163,
                            20026,
                        ].includes(i.typing.id)
                    ) {
                        type = `${i.typing.name} ${i.typing.typing.name}`;
                    } else {
                        type = i.typing.name;
                    }

                    tickets.push({
                        serial: i.id,
                        type,
                        date: setFormatDate(i.creationDate),
                        state: getStateOfTicket(i.status.name),
                        name: i.name,
                        creationDate: i.creationDate,
                    });
                });
            }

            return tickets;
        },
    },
    mutations: {
        [TICKETS_DASHBOARD_SET_TICKETS](state, tickets) {
            state.tickets = tickets;
        },
        [TICKETS_DASHBOARD_SET_PAGINATED_TICKETS](state, paginatedTickets) {
            state.paginatedTickets = paginatedTickets;
        },
    },
    actions: {
        async [TICKETS_DASHBOARD_GET_TICKETS]({ rootGetters, commit }) {
            try {
                const currentUser: User = rootGetters[`user/${UserGetters.GET_CURRENT_USER}`];
                const customer = currentUser.contact.customer;
                await apiService.getTickets(customer.id).then(res => {
                    commit(TICKETS_DASHBOARD_SET_TICKETS, res.data);
                });

                return true;
            } catch (e) {
                return false;
            }
        },
        async [TICKETS_DASHBOARD_FETCH_PAGINATION_TICKETS](
            { commit, rootGetters },
            pagination: { limit: number; start: number },
        ) {
            try {
                const currentUser: User = rootGetters[`user/${UserGetters.GET_CURRENT_USER}`];
                const customer = currentUser.contact.customer;
                await apiService
                    .getPaginationTickets({ customerid: customer.id, ...pagination })
                    .then(res => {
                        commit(TICKETS_DASHBOARD_SET_PAGINATED_TICKETS, res.data);
                    });
                return true;
            } catch (e) {
                return false;
            }
        },
        async [TICKETS_DASHBOARD_FETCH_TICKETS_BY_FILTER]({ commit }, payload) {
            const res = await apiService.getTicketsByFilter(payload);
            commit(TICKETS_DASHBOARD_SET_PAGINATED_TICKETS, res.data);
        },
    },
};

export default ticketsDashboard;
